import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { InAppBrowser } from '@ionic-native/in-app-browser';

@Component({
  selector: 'page-support',
  templateUrl: 'support.html',
})
export class SupportPage {

  constructor(public navCtrl: NavController, public navParams: NavParams, private inAppBrowser: InAppBrowser) {
  }

  openSupportLink() {
    this.inAppBrowser.create(
      'https://siemens.com/energy-support/',
      '_system', 'location=yes'
    );
  }

}



// WEBPACK FOOTER //
// ./src/pages/support/support.ts